import { queryOptions } from "@tanstack/react-query";

import * as auth from "@skilitics/auth-client";
import getAuthClient from "@skilitics/designer-auth";

import { silenceError } from "../../../errors/silenceError.ts";
import type { RouteApiErrorCode } from "./RouteErrorView.tsx";

export class ExpectedError extends Error {
  name = "ExpectedError";
  code: RouteApiErrorCode;

  constructor(code: RouteApiErrorCode) {
    super(`Received expected response error code: ${code}`);
    this.code = code;
  }
}

export const membersQueryOptions = queryOptions({
  queryKey: ["org", "members"],
  queryFn: async () => {
    try {
      return await getAuthClient().fetchMembers();
    } catch (error) {
      if (error instanceof auth.AuthApiError) {
        switch (error.code) {
          case "requires-admin":
            throw silenceError(new ExpectedError(error.code));
        }
      }
      throw error;
    }
  },
});
